import { IDataGridToolbarControls } from '../../model';

export type BarControlKey = keyof IDataGridToolbarControls;

/**
 * N2b (PD-10, T3): below md a grid's bar is one row -- the search, the filters
 * button, the sort, the actions, the kebab. The actions it shows are at most
 * MOBILE_BAR_VISIBLE of the config's visible buttons (`controlsDefault`), in
 * this order: "add new" first (the screen's action), then refresh, export,
 * reset filters. The rest move into the bar's kebab (`Controls`), with the
 * same handlers and the same permission checks. Two icons leave the search
 * ~100 px at 360 beside the filters, sort and kebab.
 */
export const MOBILE_BAR_ORDER: BarControlKey[] = ['new', 'refresh', 'export', 'resetFilters'];
export const MOBILE_BAR_VISIBLE = 2;

export interface BarSplit {
  visible: BarControlKey[];
  overflow: BarControlKey[];
}

export const splitBarControls = (
  controls: IDataGridToolbarControls | null | undefined,
): BarSplit => {
  const present = MOBILE_BAR_ORDER.filter((key) => Boolean(controls?.[key]));
  return {
    visible: present.slice(0, MOBILE_BAR_VISIBLE),
    overflow: present.slice(MOBILE_BAR_VISIBLE),
  };
};
